import React, { useEffect, useState } from 'react'
import DataDisplayer, { IDataDisplayerHeaderOptionActionButton, IDataDisplayerItem, IDataDisplayerItemField, IDataDisplayerPagination } from '../../components/DataDisplayer/DataDisplayer'
import { useDispatch } from 'react-redux'
import ItemsApp, { IItemModel } from './ItemsApp'
import { ISearchParam } from '../BaseApp'
import { handleRequestError } from '../../services/api'
import { updateDisplayerItems } from '../../components/DataDisplayer/dataDisplyerSlice'
import ItemsList from './ItemsList'
import { handleCustomUpdateItem } from './itemsSlice'
import WarehousesApp from '../warehouses/WarehousesApp'
import SectionsApp from '../sections/SectionsApp'
import BrandsApp from '../brands/BrandsApp'

interface IProps {
    addItems: (items: number[]) => void,
    reset: boolean,
    addItemInstances?: (items: IItemModel[]) => void,
}

export default function SelectItems(props: IProps) {

    const dispatch = useDispatch()

    const { addItems, reset, addItemInstances } = props

    const itemsApp = new ItemsApp()

    const [items, setItems] = useState<IItemModel[]>([])
    const [dataDisplayerItems, setDataDisplayerItems] = useState<IDataDisplayerItem[]>([])
    const [pagination, setPagination] = useState<IDataDisplayerPagination>({
        count: 0,
        current_page: 0,
        total_pages: 0
    })
    const [search, setSearch] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(true)
    const [selectedItems, setSelectedItems] = useState<IItemModel[]>([])
    const [searchParams, setSearchParams] = useState<ISearchParam[]>([])

    useEffect(() => {
        if (reset){
            setItems([])
            setSearch("")
            setSelectedItems([])
            setSearchParams([])
        }
    }, [reset])

    return(
        <ItemsList
            // customGridDataConfig={{
            //     viewItemLink: "",
            //     editItemLink: "",
            //     disableActionButtons: true,
            //     disableDelete: true,
            // }}
            customGridHeaderOptions={[
                {
                    label: "Add Items",
                    icon: "new",
                    disabled: selectedItems.length > 0 ? false : true,
                    onClick() {
                        
                        let ids: number[] = []

                        if (selectedItems.length > 0) {
                            selectedItems.map((item) => ids.push(item.id))
                        }

                        addItems(ids)

                        if (addItemInstances){
                            addItemInstances(selectedItems)
                        }

                    },
                }
            ]}
            customLoading={loading}
            customItems={items}
            customPagination={pagination}
            customSearch={search}
            customSelectedItems={selectedItems}
            customSearchParams={searchParams}
            customUpdateSearch={(search) => setSearch(search)}
            customSetSelectedItems={(items) => setSelectedItems(items)}
            customUpdateLoadingStatus={(status) => setLoading(status)}
            customUpdateSearchParams={(params) => setSearchParams(params)}
            customAddNewItem={(item) => {
                setItems([
                    ...items,
                    item
                ])
            }}
            customUpdateItem={(item) => handleCustomUpdateItem(items, item)}
            customUpdateAllItems={(items) => {
                console.log("items selected",items)
                setItems(items)
            }}
            customUpdatePagination={(pagination) => setPagination(pagination)}
            disableRedirectAfterScan={true}
            disableActionButton
            disableDelete
        />
    )
}